// Reading.tsx
import React, { useState } from 'react';
import './Reading.css';
import atomicHabits from '../images/atomic_habits.jpg';
import richDadPoorDad from '../images/TLMP.jpg';
import alchemist from '../images/alchemist.jpg';
import eatThatFrog from '../images/Verity.jpg';
import vijayanikiAidhuMetlu from '../images/ikigai.jpg';

const books = [
  {
  title: "Atomic Habits",
  author: "James Clear",
  imgSrc: atomicHabits,
  description: "A practical self-improvement book about building good habits, breaking bad ones, and making small changes for remarkable results.",
  rating: "4.8",
  genre: "Self-Help"
},
{
  title: "The Last Mrs. Parrish",
  author: "Liv Constantine",
  imgSrc: richDadPoorDad,
  description: "A psychological thriller about a woman who schemes her way into the life of a wealthy couple hiding dangerous secrets.",
  rating: "4.2",
  genre: "Psychological Thriller"
},
{
  title: "The Alchemist",
  author: "Paulo Coelho",
  imgSrc: alchemist,
  description: "A philosophical fiction novel following a shepherd boy’s journey to discover his destiny and personal legend.",
  rating: "4.7",
  genre: " Fiction"
},
{
  title: "Verity",
  author: "Colleen Hoover",
  imgSrc: eatThatFrog,
  description: "A dark psychological thriller where a writer uncovers disturbing secrets while completing another author’s unfinished manuscript.",
  rating: "4.3",
  genre: "Psychological Thriller"
},
{
  title: "Ikigai",
  author: "Héctor García & Francesc Miralles",
  imgSrc: vijayanikiAidhuMetlu,
  description: "A motivational book exploring the Japanese philosophy of finding purpose, balance, happiness, and longevity in life.",
  rating: "4.1",
  genre: "Self-Help"
}
];

const Reading: React.FC = () => {
  const [, setHoveredBook] = useState<number | null>(null);

  return (
    <div className="netflix-reading-container">
      <div className="netflix-header">
        <h1 className="netflix-title">📚 My Reading Collection</h1>
        <h2 className="netflix-subtitle">Books That Shaped My Journey</h2>
        <p className="netflix-description">
          Discover the stories, insights, and wisdom that have influenced my perspectives, 
          motivation, and personal growth. Each book offers a unique journey worth exploring.
        </p>
      </div>

      <div className="books-section">
        <div className="books-row">
          {books.map((book, index) => (
            <div 
              key={index} 
              className="book-card"
              onMouseEnter={() => setHoveredBook(index)}
              onMouseLeave={() => setHoveredBook(null)}
            >
              <div className="book-cover-container">
                <img src={book.imgSrc} alt={book.title} className="book-cover" />
                <div className="play-button">
                  <div className="play-icon"></div>
                </div>
                <div className="gradient-overlay"></div>
              </div>
              
              <div className="book-info">
                <div className="book-header">
                  <h3 className="book-title">{book.title}</h3>
                  <div className="book-rating">
                    <span className="star">★</span>
                    <span>{book.rating}</span>
                  </div>
                </div>
                
                <div className="book-meta">
                  <span className="book-author">{book.author}</span>
                  <span className="book-genre">{book.genre}</span>
                </div>
                
                <p className="book-description">{book.description}</p>
                
                <div className="action-buttons">
                  <button className="btn btn-primary">
                    <span>▶</span> Read Now
                  </button>
                  <button className="btn btn-secondary">
                    <span>+</span> My List
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reading;